/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface RunnerUpdateDto
 */
export interface RunnerUpdateDto {
    /**
     *
     * @type {string}
     * @memberof RunnerUpdateDto
     */
    runnerId?: string;
    /**
     *
     * @type {string}
     * @memberof RunnerUpdateDto
     */
    status?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof RunnerUpdateDto
     */
    enabled?: boolean;
    /**
     *
     * @type {string}
     * @memberof RunnerUpdateDto
     */
    settings?: string | null;
    /**
     *
     * @type {Date}
     * @memberof RunnerUpdateDto
     */
    lastRun?: Date | null;
}

export function RunnerUpdateDtoFromJSON(json: any): RunnerUpdateDto {
    return RunnerUpdateDtoFromJSONTyped(json, false);
}

export function RunnerUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunnerUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'runnerId': !exists(json, 'runnerId') ? undefined : json['runnerId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'settings': !exists(json, 'settings') ? undefined : json['settings'],
        'lastRun': !exists(json, 'lastRun') ? undefined : (json['lastRun'] === null ? null : new Date(json['lastRun'])),
    };
}

export function RunnerUpdateDtoToJSON(value?: RunnerUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'runnerId': value.runnerId,
        'status': value.status,
        'enabled': value.enabled,
        'settings': value.settings,
        'lastRun': value.lastRun === undefined ? undefined : (value.lastRun === null ? null : value.lastRun.toISOString()),
    };
}

